import axios from "axios"
import { DEPARTMENT_API_URL } from "../Api-end-points";


export class DepartmentService {
    static async fetch() {
        return await axios.get(`${DEPARTMENT_API_URL}`).then((res) => res.data);
    }
}